import { c as _c } from "react/compiler-runtime";
import { Box, Divider, IconButton, Stack, styled, Typography } from '@mui/material';
import { BackupPolicyType, Provider, ScheduleMode, type BackupPolicyConfig } from '@repo/api-gw-sdk';
import { useState } from 'react';
import { BackupPolicyTypeTag } from '@/app/(dashboard)/settings/backup-policies/backupPolicyTypeTag';
import { getFrequencyByWindow, getFrequencyDisplayName } from '@/app/(dashboard)/settings/frequency';
import type { BackupVault } from '@/data/vaults/backupVault';
import { fromDaysToBiggestAsPossible } from '@/utils/dateTime';
import { SnapshotIndicator } from '../snapshots/SnapshotIndicator';
import { Tag } from '../tag';
import { BackupVaultCard } from '../vaults/backupVaultCard';
import { AccountAsVaultTag } from '../vaults/vaultTag';
const SelectableIconBtn = styled(IconButton)<{
  selected?: boolean;
}>(({
  selected
}) => ({
  border: selected ? `1px solid var(--mui-palette-text-primary)` : 'none',
  padding: '4px',
  margin: selected ? '0 4px' : 'none',
  borderRadius: '50%'
}));
export function BackupPolicyPopperCard(t0) {
  const $ = _c(25);
  const {
    policy,
    vaults
  } = t0;
  const isAzureFiles = policy.policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES;
  const [selectedSchedule, setSelectedSchedule] = useState(policy.schedules.length > 0 ? policy.schedules[0] : null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundColor: "var(--mui-palette-background-paper)",
      boxShadow: "var(--mui-customShadows-panel)",
      width: "368px",
      padding: "24px",
      paddingBottom: "12px",
      borderRadius: "16px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== policy.name) {
    t2 = <Typography variant="h6">{policy.name}</Typography>;
    $[1] = policy.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== policy.policyType) {
    t3 = <BackupPolicyTypeTag policyType={policy.policyType} />;
    $[3] = policy.policyType;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== policy.enabled) {
    t4 = !policy.enabled && <Tag content="Disabled" disabled={true} />;
    $[5] = policy.enabled;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <Stack className="mb-[32px]" gap="12px" direction="row" alignItems="center">{t2}{t3}{t4}</Stack>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isAzureFiles || $[12] !== policy || $[13] !== selectedSchedule || $[14] !== vaults) {
    t6 = isAzureFiles ? <AzureFilesPolicyContent selectedSchedule={selectedSchedule} /> : <StandardPolicyContent policy={policy} vaults={vaults} selectedSchedule={selectedSchedule} />;
    $[11] = isAzureFiles;
    $[12] = policy;
    $[13] = selectedSchedule;
    $[14] = vaults;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== isAzureFiles || $[17] !== policy.schedules || $[18] !== selectedSchedule || $[19] !== vaults) {
    t7 = policy?.schedules.length > 1 ? <><Stack direction="row" alignItems="center" justifyContent="space-between" sx={{
        margin: "0 -24px",
        marginTop: "24px",
        padding: "12px 24px",
        paddingBottom: 0,
        borderTop: "1px solid var(--mui-palette-divider)"
      }}><Typography variant="body1">{`${selectedSchedule ? (policy?.schedules.findIndex(p => p.id === selectedSchedule?.id) ?? 0) + 1 : 1} of ${policy?.schedules?.length ?? 0}`}</Typography><Stack direction="row" alignItems="center" gap="4px"><IconButton size="small" onClick={() => {
            const currentIndex = selectedSchedule ? policy.schedules.findIndex(s => s.id === selectedSchedule.id) : 0;
            setSelectedSchedule(policy.schedules[(currentIndex - 1 + policy.schedules.length) % policy.schedules.length]);
          }}><i className="material-symbols-chevron-left-rounded" /></IconButton>{policy.schedules.map(schedule => {
            const vault = vaults.find(v => v.id === schedule.vaultId);
            const selected = selectedSchedule?.id === schedule.id;
            return <SelectableIconBtn size="small" key={schedule.id} selected={selected} onClick={() => {
              if (!selected) {
                setSelectedSchedule(schedule);
              }
            }}><SnapshotIndicator backgroundColor={isAzureFiles ? null : vault?.backgroundColor || null} /></SelectableIconBtn>;
          })}<IconButton size="small" onClick={() => {
            const currentIndex_0 = selectedSchedule ? policy.schedules.findIndex(s_0 => s_0.id === selectedSchedule.id) : 0;
            setSelectedSchedule(policy.schedules[(currentIndex_0 + 1) % policy.schedules.length]);
          }}><i className="material-symbols-chevron-right-rounded" /></IconButton></Stack></Stack></> : <div className="mb-[12px]" />;
    $[16] = isAzureFiles;
    $[17] = policy.schedules;
    $[18] = selectedSchedule;
    $[19] = vaults;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <Box onClick={_temp} onMouseDown={_temp2} sx={t1}>{t5}{t6}{t7}</Box>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}
const AzureFilesPolicyContent = t0 => {
  const $ = _c(14);
  const {
    selectedSchedule
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Stack direction="row" alignItems="center" gap="40px"><Typography className="min-w-[86px]" variant="subtitle1">Frequency</Typography><Typography>Daily</Typography></Stack>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Typography className="min-w-[86px]" variant="subtitle1">Retention</Typography>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== selectedSchedule) {
    t4 = selectedSchedule?.backupRetention ? formatRetention(selectedSchedule.backupRetention) : "\u2014";
    $[3] = selectedSchedule;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <Stack direction="row" alignItems="center" gap="40px">{t3}<Typography>{t4}</Typography></Stack>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Typography className="min-w-[86px]" variant="subtitle1">Stored in</Typography>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = selectedSchedule?.region || "Source region";
  let t9;
  if ($[9] !== t8) {
    t9 = <Stack direction="row" alignItems="center" gap="40px">{t7}<AccountAsVaultTag cloudProvider={Provider.Azure} region={t8} /></Stack>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t5 || $[12] !== t9) {
    t10 = <Stack gap="16px">{t1}{t2}{t5}{t6}{t9}</Stack>;
    $[11] = t5;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
};
const StandardPolicyContent = t0 => {
  const $ = _c(26);
  const {
    policy,
    vaults,
    selectedSchedule
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography className="min-w-[86px]" variant="subtitle1">Frequency</Typography>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = selectedSchedule && getFrequencyByWindow(selectedSchedule.windows)?.text;
  let t3;
  if ($[1] !== t2) {
    t3 = <Typography>{t2}</Typography>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== policy.scheduleMode || $[4] !== selectedSchedule) {
    t4 = policy.scheduleMode === ScheduleMode.SCHEDULE_MODE_ADVANCED && selectedSchedule && <Typography>{getFrequencyDisplayName(selectedSchedule.windows)}</Typography>;
    $[3] = policy.scheduleMode;
    $[4] = selectedSchedule;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Stack direction="row" alignItems="start" gap="40px">{t1}<Stack gap="8px">{t3}{t4}</Stack></Stack>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Typography className="min-w-[86px]" variant="subtitle1">Retention</Typography>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== selectedSchedule) {
    t8 = selectedSchedule?.backupRetention && formatRetention(selectedSchedule.backupRetention);
    $[11] = selectedSchedule;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <Stack direction="row" alignItems="center" gap="40px">{t7}<Typography>{t8}</Typography></Stack>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    t11 = <Typography className="min-w-[86px]" variant="subtitle1">Vault</Typography>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t10 = $[15];
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t5 || $[18] !== t9) {
    t12 = <Stack gap="16px">{t5}{t6}{t9}{t10}{t11}</Stack>;
    $[17] = t5;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== selectedSchedule || $[21] !== vaults) {
    t13 = <div className="mt-[16px]">{selectedSchedule ? <BackupVaultCard editable={false} data={vaults.find(v => v.id === selectedSchedule.vaultId)} /> : <BackupVaultCard loading={true} editable={false} />}</div>;
    $[20] = selectedSchedule;
    $[21] = vaults;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12 || $[24] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
};
const formatRetention = (backupRetention: number) => {
  const formattedRetention = fromDaysToBiggestAsPossible(backupRetention);
  return `${formattedRetention.value} ${formattedRetention.unit}${formattedRetention.unit !== 'days' ? ` (${backupRetention} days)` : ''}`;
};